var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"page-ecommerce-card-modal","ok-title":_vm.trans(_vm.block && _vm.block.id ? 'save' : 'create'),"cancel-title":_vm.trans('cancel'),"size":"lg","no-enforce-focus":""},on:{"shown":_vm.onShown,"hidden":function($event){_vm.shown = false},"ok":_vm.onSave},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.trans('ecommerce')))]),_vm._v(" "),(!!_vm.block)?_c('small',{staticClass:"text-muted ml-2"},[_vm._v("\n    #"+_vm._s(_vm.block.id)+"\n  ")]):_vm._e()]},proxy:true}])},[_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"col-12"},[_c('DynamicForm',{attrs:{"fields":[
                {
                    label: _vm.trans('items_type'),
                    key: 'items_type',
                    type: 'checkboxgroup',
                    options: [
                        { text: _vm.trans('products'), value: 'products' },
                        { text: _vm.trans('memberships'), value: 'memberships' },
                        { text: _vm.trans('classes'), value: 'classes' },
                        { text: _vm.trans('packages'), value: 'packages', disabled: true } ],
                    tab: _vm.trans('request_ecommmerce'),
                },
                {
                    label: _vm.trans('category'),
                    key: 'category_id',
                    desc: _vm.trans('category_ecommerce_desc'),
                    url: ("/organization/" + (_vm.organization.id) + "/category"),
                    type: 'category',
                    tab: _vm.trans('request_ecommmerce'),
                },
                {
                    label: _vm.trans('exclude_category'),
                    key: 'exclude_ids',
                    url: ("/organization/" + (_vm.organization.id) + "/category/list?per_page=100"),
                    type: 'tags',
                    tab: _vm.trans('request_ecommmerce'),
                },
                {
                    inside: _vm.trans('hide_empty_categories'),
                    key: 'hide_empty',
                    type: 'checkbox',
                    switch: true,
                    tab: _vm.trans('options'),
                },
                {
                    inside: _vm.trans('force_list_view'),
                    key: 'list_view',
                    type: 'checkbox',
                    switch: true,
                    tab: _vm.trans('options'),
                },
                {
                    label: _vm.trans('item_size'),
                    key: 'item_size',
                    type: 'radioboxgroup',
                    options: [
                        {text: '25%', value: 0.25},
                        {text: '33%', value: 0.3333},
                        {text: '50%', value: 0.5},
                        {text: '100%', value: 1.0} ],
                    tab: _vm.trans('options'),
                },
                {
                    label: _vm.trans('default_form'),
                    key: 'default_form',
                    type: 'category',
                    //desc: trans('default_form_desc'),
                    url: ("/organization/" + (_vm.organization.id) + "/checkout_form"),
                    tab: _vm.trans('options'),
                },
                {
                    organization: _vm.organization,
                    inside: _vm.trans('show_participant'),
                    key: 'participant',
                    type: 'participant',
                    tab: _vm.trans('options'),
                } ],"busy":_vm.busy},model:{value:(_vm.formValues),callback:function ($$v) {_vm.formValues=$$v},expression:"formValues"}}),_vm._v(" "),(!_vm.hideClassOptions)?_c('b-form-group',{attrs:{"label":_vm.trans('participant_fields')}},[_c('FormParticipantFields',{attrs:{"organization":_vm.organization},model:{value:(_vm.participant),callback:function ($$v) {_vm.participant=$$v},expression:"participant"}})],1):_vm._e()],1)],1),_vm._v(" "),(_vm.busy)?_c('p',[_c('i',{staticClass:"fa fa-fw fa-circle-notch fa-spin"}),_vm._v("\n    "+_vm._s(_vm.trans('please_wait'))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"text-danger"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }